export default __webpack_public_path__ + "static/media/work4.2c270034.jpg";